import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionChartDTO  {
    _originalTypeClassName = "zERP.BO.TransactionChartDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionChartDTO.translate = translateService;
}
this.Category = null;
this.Value = null;
this.Month = null;
this.SalesAmount = null;
this.PurchasesAmount = null;
this.AccountingEntriesAmount = null;
this.IncomeVatAmount = null;
this.ExpensesVatAmount = null;
this.TransactionChartDTOKey = null;
this._key = this.TransactionChartDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Category:any;
Value:any;
Month:any;
SalesAmount:any;
PurchasesAmount:any;
AccountingEntriesAmount:any;
IncomeVatAmount:any;
ExpensesVatAmount:any;
private _TransactionChartDTOKey:any;
get TransactionChartDTOKey(): any {
    return this._TransactionChartDTOKey;
  }
set TransactionChartDTOKey(value: any) {
    this._TransactionChartDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TransactionChartDTOKey == null || $this.TransactionChartDTOKey == 0;
            }


}